export const priceBuckets = [
  { id: 'u250', label: 'Under €250', min: 0, max: 250 },
  { id: '250-1000', label: '€250 – €1,000', min: 250, max: 1000 },
  { id: '1000-2500', label: '€1,000 – €2,500', min: 1000, max: 2500 },
  { id: 'o2500', label: '€2,500 +', min: 2500, max: Infinity },
] as const;

export const capacityBuckets = [
  { id: 'u1', label: 'Under 1 kWh', min: 1, max: 1000 },
  { id: '1-3', label: '1 – 3 kWh', min: 1000, max: 3000 },
  { id: '3-10', label: '3 – 10 kWh', min: 3000, max: 10000 },
  { id: 'o10', label: '10 kWh +', min: 10000, max: Infinity },
] as const;

export const sortOptions = [
  { id: 'popular', label: 'Most popular' },
  { id: 'price-asc', label: 'Price: low to high' },
  { id: 'price-desc', label: 'Price: high to low' },
  { id: 'rating', label: 'Best rated' },
] as const;

export const reviews = [
  {
    name: 'Marieke V.',
    location: 'Utrecht',
    rating: 5,
    date: 'Sep 2026',
    text: 'Ordered on Monday, installed the next week. The app shows exactly how much we save — about €60 a month so far.',
  },
  {
    name: 'Thomas de B.',
    location: 'Gent',
    rating: 5,
    date: 'Aug 2026',
    text: 'Clear advice on the phone, they talked me out of the bigger model I didn’t need. Fast delivery, well packed.',
  },
  {
    name: 'Sanne K.',
    location: 'Eindhoven',
    rating: 4,
    date: 'Aug 2026',
    text: 'Great product, setup took a bit longer than expected but support helped me through it within minutes.',
  },
];
